/*
 * INC-26068: a report whose Meaningful Strengths and Key Growth Opportunities were chosen by
 * distance from the benchmark carries results.ranking = "benchmarkGap" (set by fsci-api).
 * Reports generated before that keep the lists picked the original way, so they must keep
 * the original wording that describes that method.
 */

export const BENCHMARK_GAP_RANKING = "benchmarkGap";

export const isBenchmarkRanked = (results: { readonly ranking?: string }): boolean =>
    results.ranking === BENCHMARK_GAP_RANKING;
